import angular from 'angular';

import gridHeight from '../../core/shared-service/grid-utils';



class ModalGroupAddCompaniesCtrl {
    $onInit() {
    	var ctrl = this;
    	
    	// Gestion de la grille
        this.gridOptions = {
            columnDefs: [
                { name: 'name', displayName: 'Raison sociale'},
                { name: 'idFiscal', displayName: 'ID Fiscal'},
                { name: 'idNational', displayName: 'ID Légal'}
            ],
            paginationPageSize: 10,
            paginationPageSizes: [10, 50],
            enableSorting: true,
            enableGridMenu: false,
            enableColumnMenus: false,
            onRegisterApi: function(gridApi) {
                ctrl.gridApi = gridApi;
            }
        };

        this.gridOptions.data = this.resolve.companies.filter(company => {
        	if (ctrl.resolve.currentCompanies.find(element => element.id === company.id)) {
        		return false;
        	}
        	return company; 
		});
        this.gridOptions.totalItems = this.gridOptions.data.length;
    }

    cancel() {
        this.modalInstance.dismiss('cancel');
    }
    
    /**
     * Filtre les sociétés du tableau.
     */
    filterChange() {
		var ctrl = this;
		this.gridOptions.data = this.resolve.companies.filter(company => 
			{
				if (ctrl.resolve.currentCompanies.find(element => element.id === company.id) === undefined && (
						(company.name && company.name.toLowerCase().indexOf(this.filterValue.toLowerCase()) !== -1) ||
						(company.idFiscal && company.idFiscal.toLowerCase().indexOf(this.filterValue.toLowerCase()) !== -1 ) ||
						(company.idNational && company.idNational.toLowerCase().indexOf(this.filterValue.toLowerCase()) !== -1))) {
					return true
				}
				return false;
			}
		)
    	this.gridOptions.totalItems = this.gridOptions.data.length;
    }
    
    confirm() {
    	var rows = this.gridApi.selection.getSelectedRows();
    	if (rows) {
    		this.modalInstance.close(rows);
    	}
    }
    
    /**
     * Fournit la hauteur optimale de la grid en fonction du nombre d'element par page.
     */
    getGridHeight() {
        return gridHeight(this.gridApi);
    }
}

angular.module('app.principal').component('modalGroupAddCompanies', {
    templateUrl: require('./modal-group-add-companies.html'),
    controller: ModalGroupAddCompaniesCtrl,
    bindings: {
        resolve: '<',
        modalInstance: '<'
    }
});
